import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { questions } from '../data/questionsData';

// Quiz reutilizável. Renderiza as perguntas e devolve as respostas via onComplete.
// Uso:  <QuizRunner titulo="A vez da Ana" onComplete={(answers)=>...} onBack={...} />
const OPCOES = [
  { value: 1, label: 'Discordo totalmente' },
  { value: 2, label: 'Discordo parcialmente' },
  { value: 3, label: 'Neutro' },
  { value: 4, label: 'Concordo parcialmente' },
  { value: 5, label: 'Concordo totalmente' },
];

const QuizRunner = ({ titulo, subtitulo, onComplete, onBack }) => {
  const [i, setI] = useState(0);
  const [answers, setAnswers] = useState({});
  const q = questions[i];
  const val = answers[q.id] || 0;
  const progress = ((i + 1) / questions.length) * 100;

  const responder = (value) => {
    const novo = { ...answers, [q.id]: value };
    setAnswers(novo);
    if (i < questions.length - 1) setTimeout(() => setI(i + 1), 380);
    else onComplete(novo);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-indigo-900 to-[#0a1628]">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-6 relative">
          {onBack && (
            <button onClick={onBack} className="absolute left-0 top-0 flex items-center gap-2 text-white/70 hover:text-white" style={{ border:'none', background:'transparent' }}>
              <ArrowLeft className="w-5 h-5" /> <span>Voltar</span>
            </button>
          )}
          <h1 className="text-xl md:text-2xl font-bold text-white mb-1">{titulo || 'Teste das Estações do Coração'}</h1>
          <p className="text-white/70 text-sm">{subtitulo || 'Responda com sinceridade'}</p>
        </div>

        <div className="max-w-2xl mx-auto mb-8">
          <div className="relative bg-white/20 rounded-full h-2 mb-2" style={{ isolation:'isolate' }}>
            <div className="absolute left-0 top-0 bg-white h-full rounded-full" style={{ width:`${progress}%`, transition:'width 0.3s ease-out', minWidth: progress>0?'8px':'0' }} />
          </div>
          <p className="text-center text-white/60 text-sm">{Math.round(progress)}% concluído</p>
        </div>

        <div className="max-w-2xl mx-auto mb-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
            <div className="text-center mb-2 text-white/50 text-sm">Pergunta {i + 1} de {questions.length}</div>
            <p className="text-white text-lg md:text-xl leading-relaxed text-center">{q.text}</p>
          </div>
        </div>

        <div className="max-w-2xl mx-auto space-y-3 mb-8">
          {OPCOES.map(({ value, label }) => (
            <button key={value} onClick={() => responder(value)} style={{ border:'none', outline:'none' }}
              className={`w-full py-4 px-6 rounded-xl text-left flex items-center transition-all duration-300 ${val===value ? 'bg-gradient-to-r from-blue-500 to-indigo-500 scale-[1.02]' : 'bg-white/10 hover:bg-white/20 backdrop-blur-sm'}`}>
              <span className={`w-10 h-10 rounded-full flex items-center justify-center mr-4 text-sm font-semibold ${val===value ? 'bg-white text-indigo-600' : 'bg-white/20 text-white'}`}>{value}</span>
              <span className="text-white">{label}</span>
            </button>
          ))}
        </div>

        <div className="flex justify-between items-center max-w-2xl mx-auto">
          <button onClick={() => setI(Math.max(0, i - 1))} disabled={i===0} style={{ border:'none' }}
            className={`flex items-center gap-2 px-5 py-2 rounded-xl ${i===0 ? 'text-white/30 cursor-not-allowed' : 'text-white bg-white/10 hover:bg-white/20'}`}>
            <ArrowLeft className="w-4 h-4" /> <span>Anterior</span>
          </button>
          {i < questions.length - 1 && val > 0 && (
            <button onClick={() => setI(i + 1)} style={{ border:'none' }}
              className="flex items-center gap-2 px-5 py-2 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:from-blue-600 hover:to-indigo-600">
              <span>Próxima</span> <ArrowRight className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
export default QuizRunner;
